<template>
  <!-- 工单管理 -->
  <div class="repair_order-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-switch
            v-model="switch_status"
            :active-value="1"
            :inactive-value="0"
            active-text="开启工单"
            inactive-text="关闭工单"
            @change="changeEvent"
          ></el-switch>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="query.user_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.type">
            <el-option :value="undefined" label="请选择工单类型"
              >全部</el-option
            >
            <!-- <el-option :value="5" label="盈亏相关"></el-option>
            <el-option :value="1" label="支付相关"></el-option>
            <el-option :value="2" label="账号相关"></el-option>
            <el-option :value="3" label="库存相关"></el-option>
            <el-option :value="4" label="BUG相关"></el-option>
            <el-option :value="6" label="生日福利"></el-option> -->
            <el-option :value="1" label="正常工单"></el-option>
            <el-option :value="2" label="生日工单"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.status">
            <el-option :value="undefined" label="请选择工单状态"
              >全部</el-option
            >
            <el-option :value="1" label="待解决"></el-option>
            <el-option :value="2" label="已解决"></el-option>
            <el-option :value="3" label="已关闭"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="query.start_time"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="query.end_time"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="query.num"
            placeholder="请输入提交工单次数"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-switch
            v-model="limit_status"
            :active-value="1"
            :inactive-value="0"
            active-text="开启提交限制(1次)"
            inactive-text="关闭提交限制"
            @change="changeLimitRepairOrder"
          ></el-switch>
        </el-form-item>
        <el-form-item>
          <el-switch
            v-model="week_status"
            :active-value="1"
            :inactive-value="0"
            active-text="开启周末工单"
            inactive-text="关闭周末工单"
            @change="changeWeekStatus"
          ></el-switch>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="success" @click="getUnlock()"
            >解除全部封禁</el-button
          >
        </el-form-item> -->
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="listData"
        v-loading="loading"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="id" label="工单id" align="center">
        </el-table-column>
        <el-table-column prop="user_id" label="用户uid" align="center">
          <template slot-scope="{ row }">
            <span :style="`${row.human_feelings === 1 ? 'color:blue' : ''}`">{{
              row.user_id
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="is_banned" label="用户状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.is_banned === 1">正常</el-tag>
            <el-tag type="danger" v-if="row.banned === 1">封禁7天</el-tag>
            <el-tag type="danger" v-if="row.banned === 2">封禁1月</el-tag>
            <el-tag type="danger" v-if="row.banned === 4">封禁永久</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="submit_num"
          label="本月提交工单次数"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="title" label="工单标题" align="center">
        </el-table-column>
        <el-table-column prop="type" label="工单类型" align="center">
          <template slot-scope="{ row }">
            <!-- <span v-if="row.type === 5">盈亏相关</span>
            <span v-if="row.type === 1">支付相关</span>
            <span v-if="row.type === 2">账号相关</span>
            <span v-if="row.type === 3">库存相关</span>
            <span v-if="row.type === 4">BUG相关</span>
            <span v-if="row.type === 6">生日福利</span> -->
            <span
              v-if="
                row.type == 1 ||
                row.type == 2 ||
                row.type == 3 ||
                row.type == 4 ||
                row.type == 5
              "
              >正常工单</span
            >
            <span v-if="row.type === 6">生日工单</span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="工单内容" align="center">
        </el-table-column>
        <el-table-column prop="status" label="工单状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="warning" v-if="row.status === 1">待解决</el-tag>
            <el-tag type="success" v-if="row.status === 2">已解决</el-tag>
            <el-tag type="danger" v-if="row.status === 3">已关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否福利已领完" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.box_key && !row.red_envelope">都没领完</span>
            <span v-else-if="!row.red_envelope">累充没领完</span>
            <span v-else-if="row.box_key">钥匙没领完</span>
            <span v-else>已领完</span>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="解决日期" align="center">
        </el-table-column>
        <el-table-column prop="created_at" label="创建日期" align="center">
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="操作"
          align="center"
          width="200px"
        >
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              v-if="row.status != 2"
              @click="openReplyDialog(row)"
            >
              回复
            </el-button>
            <el-button type="primary" v-else @click="openReplyDialog(row)"
              >已回</el-button
            >

            <el-dropdown
              style="margin-left: 10px"
              @command="bannedEvent"
              v-if="row.is_banned === 1"
            >
              <el-button type="danger">
                封禁<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ rowInfo: row, command: 1 }"
                  >7天</el-dropdown-item
                >
                <el-dropdown-item :command="{ rowInfo: row, command: 2 }"
                  >1月</el-dropdown-item
                >
                <el-dropdown-item :command="{ rowInfo: row, command: 4 }"
                  >永久</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="success" @click="unlockEvents(row)" v-else
              >解封</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>
    <!-- 弹窗 -->
    <!-- 回复弹窗 -->
    <ReplyUserDialog
      :visible="replyVisible"
      v-model="dialogInfo"
      @close="replyVisible = false"
      @refresh="getData"
    ></ReplyUserDialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import ReplyUserDialog from '../../components/repairorder/ReplyUserDialog.vue'

export default {
  components: {
    ReplyUserDialog
  },
  data() {
    return {
      replyVisible: false,//回复弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      switch_status: 0,//PK开关,0是关闭，1是打开
      limit_status: 0,//限制开关，0是关闭，1是打开
      week_status: 0,//周末开关，0是关闭，1是打开
      query: {//查询条件
        page: 1,
        user_id: '',//用户id
        type: undefined,//工单类型
        status: undefined,//工单状态
        start_time: '',//开始时间
        end_time: '',//结束时间
        num: undefined,//工单提交次数
      },
      dialogInfo: undefined,//传给弹窗是数据
      listData: undefined,//工单列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
    this.getSwitchStatus()//工单开关状态
    this.getLimitStatus()//工单限制开关状态
    this.getWeekStatus()//工单周末开启开关状态
  },
  methods: {
    getData(num) {
      if (num === 1) {
        //点击查询是还原下标
        this.query.page = 1
      }
      this.loading = true
      let params = JSON.parse(JSON.stringify(this.query))
      if (this.query.type === 1) {
        //主要是兼容查询和显示
        params.type = [1, 2, 3, 4, 5]
      } else if (this.query.type === 2) {
        params.type = [6]
      }
      getApiData('repair_order_record', params)
        .then(res => {
          this.listData = res.data
          //设置底部导航条数据
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    getUnlock() {
      //解除所有被封禁的用户
      this.$confirm('确认解封全部用户？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

      }).catch(() => { })
    },
    openReplyDialog(rowInfo) {
      //打开回复弹窗
      this.replyVisible = true
      this.dialogInfo = JSON.parse(JSON.stringify(rowInfo))
    },
    bannedEvent(commandInfo) {
      //封禁用户
      let params = {
        banned: commandInfo.command
      }
      patchApiData(`repair_order_reply/${commandInfo.rowInfo.id}`, params)
        .then(res => {
          this.$message.success('封禁成功！')
          this.getData()//刷新数据
        })
        .finally(() => {
        })
    },
    unlockEvents(rowInfo) {
      //解封用户
      let params = {
        banned: 3
      }
      patchApiData(`repair_order_reply/${rowInfo.id}`, params)
        .then(res => {
          this.$message.success('解封成功！')
          this.getData()//刷新数据
        })
        .finally(() => {
        })
    },
    getSwitchStatus() {
      //获取工单开关
      getApiData('repair_order_enable')
        .then(res => {
          if (res) {
            res.data ? this.switch_status = 1 : this.switch_status = 0
          }
        })
    },
    changeEvent() {
      //工单开启或关闭
      let params = { "black": this.switch_status ? 1 : 0 }
      patchApiData('repair_order_enable', params)
        .then(res => {
          this.$message.success('操作成功！')
        }).catch(err => {
          //关闭/打开按钮失败，还原标志
          this.switch_status = this.switch_status ? 0 : 1
        })

    },
    getLimitStatus() {
      //获取工单限制开关
      getApiData('once_repair_order_enable')
        .then(res => {
          if (res) {
            res.data ? this.limit_status = 1 : this.limit_status = 0
          }
        })
    },
    changeLimitRepairOrder() {
      ////工单限制打开或关闭
      let params = { "black": this.limit_status ? 1 : 0 }
      patchApiData('once_repair_order_enable', params)
        .then(res => {
          this.$message.success('操作成功！')
        }).catch(err => {
          //关闭/打开按钮失败，还原标志
          this.limit_status = this.limit_status ? 0 : 1
        })

    },
    getWeekStatus() {
      //获取工单周末是否打开
      getApiData('week_repair_order_enable')
        .then(res => {
          if (res) {
            res.data ? this.week_status = 1 : this.week_status = 0
          }
        })
    },
    changeWeekStatus() {
      //工单周末是否打开
      let params = { "black": this.week_status ? 1 : 0 }
      patchApiData('week_repair_order_enable', params)
        .then(res => {
          this.$message.success('操作成功！')
        }).catch(err => {
          //关闭/打开按钮失败，还原标志
          this.week_status = this.week_status ? 0 : 1
        })

    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    //给单行加颜色
    tableRowClassName({ row, rowIndex }) {
      if (row.is_green) {
        //为真代表是关联号已领取过生日工单
        return 'green-row'
      }
      return ''
    }
  }

}
</script>
<style lang="less" scoped>
.el-table /deep/ .green-row {
  background: #f0f9eb;
}
</style>